/**
 * Shared Book-a-Demo content factory
 * Used by every industry landing page to render an identical demo-booking
 * section. Each landing supplies only its `industry` tag (used for analytics
 * on the captured lead).
 */
import { Visibility, Tune, Schedule } from '@mui/icons-material';
/**
 * Google Appointment Schedule URL.
 * TODO: replace with the real published Google Calendar appointment URL.
 * The component appends `?email=<encoded>` (or `&email=...`) so the
 * scheduler form is prefilled.
 */
export const GOOGLE_BOOKING_URL = 'https://calendar.app.google/kZpkMWw2RH8FCuLZ7';
export const buildBookDemoContent = (industry) => ({
    title: 'See Stanor in action.\nAutomate your hiring in 15 minutes',
    bullets: [
        {
            icon: Visibility,
            title: 'Watch AI screening live',
            description: 'See how Stanor scores and qualifies real candidates against your job in seconds.',
        },
        {
            icon: Tune,
            title: 'Set up a job template',
            description: 'We help you turn your hiring criteria into a reusable scoring template.',
        },
        {
            icon: Schedule,
            title: 'Save 20+ hours a week',
            description: 'Replace manual screening, phone tag, and reminders with automation that just works.',
        },
    ],
    formTitle: 'Book a product tour.',
    formSubtitle: 'Join 400+ leading HR teams using Stanor.',
    emailPlaceholder: 'you@company.com',
    ctaText: 'Continue to Schedule',
    footerText: 'No commitment required. A low-pressure chat with our expert.',
    scheduleUrl: GOOGLE_BOOKING_URL,
    industry,
});
